"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _Box = require("../Box");

var _Popover = require("../Popover/Popover");

var _PopoverArrow = require("../PopoverArrow/PopoverArrow");

var _baseStyle = require("../shared/baseStyle");

var _styleHelpers = require("../styleHelpers");

var _useCustomStyles = require("../utils/useCustomStyles");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MenuBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Menu__MenuBox",
  componentId: "jsdonq-0"
})(["", " background-color:", ";border-radius:4px;max-width:400px;min-width:120px;padding:8px;box-shadow:0px 4px 20px rgba(0,0,0,0.2);", ""], _baseStyle.baseStyle, (0, _styleHelpers.getColor)('common', 'white'), function (props) {
  return props.css;
});

var _StyledMenuBox = (0, _styledComponents.default)(MenuBox).withConfig({
  displayName: "Menu___StyledMenuBox",
  componentId: "jsdonq-1"
})(["", ""], function (p) {
  return p._css;
});

var Menu = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      items = _ref.items,
      open = _ref.open,
      offset = _ref.offset,
      onClose = _ref.onClose,
      placement = _ref.placement,
      animation = _ref.animation,
      animationProps = _ref.animationProps,
      customStyles = _ref.customStyles;
  var getCustomStyles = (0, _useCustomStyles.useCustomStyles)('menu.styles', customStyles);
  return /*#__PURE__*/_react.default.createElement(_Popover.Popover, {
    ref: ref,
    open: open,
    offset: offset,
    onClickOutside: onClose,
    arrow: /*#__PURE__*/_react.default.createElement(_PopoverArrow.PopoverArrow, {
      size: 10,
      color: "white",
      customCss: getCustomStyles('arrow')
    }),
    placement: placement,
    content: /*#__PURE__*/_react.default.createElement(_StyledMenuBox, {
      _css: getCustomStyles('box')
    }, items),
    animation: animation,
    animationProps: animationProps
  }, children);
});
exports.Menu = Menu;